export const developer = {
  demo: {
    title: 'Demo',
  },
  resetSeed: {
    title: 'Reset Seed Data',
    description: 'Drops and re-seeds vehicles, tenants, and grant ledger entries with the default scenario.',
    button: 'Reset Seed Data',
    resetting: 'Resetting…',
    success: 'Seed data reset successfully.',
    error: 'Reset failed. Check the console for details.',
  },
  health: {
    title: 'Health',
    error: 'Failed to fetch health status.',
    timestamp: 'Timestamp',
    uptime: 'Uptime',
    uptimeValue: '{{seconds}}s',
  },
  session: {
    title: 'Session',
    user: 'User: {{name}}',
    currentTenant: 'Current tenant: {{name}}',
    apexFallback: '— (apex)',
    availableTenants: 'Available tenants: {{tenants}}',
    logout: 'Log out',
  },
};

export type DeveloperResources = typeof developer;
